/**
 * Admin form primitives (Lane D — Tamda CMS v2 brand guideline).
 *
 * Use FormShell as the page-level layout for any Create/Edit screen.
 * Group fields with FormSection inside the main column. ErrorSummary +
 * StickyActionBar + AutosaveIndicator + UnsavedWorkModal handle the
 * critical UX feedback loops.
 *
 * See ARCHITECTURE.md and the "Admin Form Redesign" section of the
 * project plan for layout conventions per form type.
 */

export { AutosaveIndicator } from "./autosave-indicator"
export { ErrorSummary } from "./error-summary"
export type { ErrorSummaryItem } from "./error-summary"
export { FormSection } from "./form-section"
export { FormShell } from "./form-shell"
export { FormSkeleton } from "./form-skeleton"
export { StickyActionBar } from "./sticky-action-bar"
export { UnsavedWorkModal } from "./unsaved-work-modal"
